module.exports = __webpack_public_path__ + "static/media/play.7d5d258f.svg";